export const SavingThrowsTable = [
  // Cleric
  { class: "Cleric", level: 1, poison: 10, poly: 13, wand: 14, breath: 16, magic: 15 },
  { class: "Cleric", level: 2, poison: 10, poly: 13, wand: 14, breath: 16, magic: 15 },
  { class: "Cleric", level: 3, poison: 10, poly: 13, wand: 14, breath: 16, magic: 15 },
  { class: "Cleric", level: 4, poison: 9, poly: 12, wand: 13, breath: 15, magic: 14 },
  { class: "Cleric", level: 5, poison: 9, poly: 12, wand: 13, breath: 15, magic: 14 },
  { class: "Cleric", level: 6, poison: 9, poly: 12, wand: 13, breath: 15, magic: 14 },
  { class: "Cleric", level: 7, poison: 7, poly: 10, wand: 11, breath: 13, magic: 12 },
  { class: "Cleric", level: 8, poison: 7, poly: 10, wand: 11, breath: 13, magic: 12 },
  { class: "Cleric", level: 9, poison: 7, poly: 10, wand: 11, breath: 13, magic: 12 },
  { class: "Cleric", level: 10, poison: 6, poly: 9, wand: 10, breath: 12, magic: 11 },
  { class: "Cleric", level: 11, poison: 6, poly: 9, wand: 10, breath: 12, magic: 11 },
  { class: "Cleric", level: 12, poison: 6, poly: 9, wand: 10, breath: 12, magic: 11 },
  { class: "Cleric", level: 13, poison: 5, poly: 8, wand: 9, breath: 11, magic: 10 },
  { class: "Cleric", level: 14, poison: 5, poly: 8, wand: 9, breath: 11, magic: 10 },
  { class: "Cleric", level: 15, poison: 5, poly: 8, wand: 9, breath: 11, magic: 10 },
  { class: "Cleric", level: 16, poison: 4, poly: 7, wand: 8, breath: 10, magic: 9 },
  { class: "Cleric", level: 17, poison: 4, poly: 7, wand: 8, breath: 10, magic: 9 },
  { class: "Cleric", level: 18, poison: 4, poly: 7, wand: 8, breath: 10, magic: 9 },
  { class: "Cleric", level: 19, poison: 2, poly: 5, wand: 6, breath: 8, magic: 7 },
  { class: "Cleric", level: 20, poison: 2, poly: 5, wand: 6, breath: 8, magic: 7 },
  // Fighter
  { class: "Fighter", level: 1, poison: 14, poly: 15, wand: 16, breath: 17, magic: 17 },
  { class: "Fighter", level: 2, poison: 14, poly: 15, wand: 16, breath: 17, magic: 17 },
  { class: "Fighter", level: 3, poison: 13, poly: 14, wand: 15, breath: 16, magic: 16 },
  { class: "Fighter", level: 4, poison: 13, poly: 14, wand: 15, breath: 16, magic: 16 },
  { class: "Fighter", level: 5, poison: 11, poly: 12, wand: 13, breath: 13, magic: 14 },
  { class: "Fighter", level: 6, poison: 11, poly: 12, wand: 13, breath: 13, magic: 14 },
  { class: "Fighter", level: 7, poison: 10, poly: 11, wand: 12, breath: 12, magic: 13 },
  { class: "Fighter", level: 8, poison: 10, poly: 11, wand: 12, breath: 12, magic: 13 },
  { class: "Fighter", level: 9, poison: 8, poly: 9, wand: 10, breath: 9, magic: 11 },
  { class: "Fighter", level: 10, poison: 8, poly: 9, wand: 10, breath: 9, magic: 11 },
  { class: "Fighter", level: 11, poison: 7, poly: 8, wand: 9, breath: 8, magic: 10 },
  { class: "Fighter", level: 12, poison: 7, poly: 8, wand: 9, breath: 8, magic: 10 },
  { class: "Fighter", level: 13, poison: 5, poly: 6, wand: 7, breath: 5, magic: 8 },
  { class: "Fighter", level: 14, poison: 5, poly: 6, wand: 7, breath: 5, magic: 8 },
  { class: "Fighter", level: 15, poison: 4, poly: 5, wand: 6, breath: 4, magic: 7 },
  { class: "Fighter", level: 16, poison: 4, poly: 5, wand: 6, breath: 4, magic: 7 },
  { class: "Fighter", level: 17, poison: 3, poly: 4, wand: 5, breath: 4, magic: 6 },
  { class: "Fighter", level: 18, poison: 3, poly: 4, wand: 5, breath: 4, magic: 6 },
  { class: "Fighter", level: 19, poison: 3, poly: 4, wand: 5, breath: 4, magic: 6 },
  { class: "Fighter", level: 20, poison: 3, poly: 4, wand: 5, breath: 4, magic: 6 },
  // Magic-User
  { class: "Magic-User", level: 1, poison: 14, poly: 13, wand: 11, breath: 15, magic: 12 },
  { class: "Magic-User", level: 2, poison: 14, poly: 13, wand: 11, breath: 15, magic: 12 },
  { class: "Magic-User", level: 3, poison: 14, poly: 13, wand: 11, breath: 15, magic: 12 },
  { class: "Magic-User", level: 4, poison: 14, poly: 13, wand: 11, breath: 15, magic: 12 },
  { class: "Magic-User", level: 5, poison: 14, poly: 13, wand: 11, breath: 15, magic: 12 },
  { class: "Magic-User", level: 6, poison: 13, poly: 11, wand: 9, breath: 13, magic: 10 },
  { class: "Magic-User", level: 7, poison: 13, poly: 11, wand: 9, breath: 13, magic: 10 },
  { class: "Magic-User", level: 8, poison: 13, poly: 11, wand: 9, breath: 13, magic: 10 },
  { class: "Magic-User", level: 9, poison: 13, poly: 11, wand: 9, breath: 13, magic: 10 },
  { class: "Magic-User", level: 10, poison: 13, poly: 11, wand: 9, breath: 13, magic: 10 },
  { class: "Magic-User", level: 11, poison: 11, poly: 9, wand: 7, breath: 11, magic: 8 },
  { class: "Magic-User", level: 12, poison: 11, poly: 9, wand: 7, breath: 11, magic: 8 },
  { class: "Magic-User", level: 13, poison: 11, poly: 9, wand: 7, breath: 11, magic: 8 },
  { class: "Magic-User", level: 14, poison: 11, poly: 9, wand: 7, breath: 11, magic: 8 },
  { class: "Magic-User", level: 15, poison: 11, poly: 9, wand: 7, breath: 11, magic: 8 },
  { class: "Magic-User", level: 16, poison: 10, poly: 7, wand: 5, breath: 9, magic: 6 },
  { class: "Magic-User", level: 17, poison: 10, poly: 7, wand: 5, breath: 9, magic: 6 },
  { class: "Magic-User", level: 18, poison: 10, poly: 7, wand: 5, breath: 9, magic: 6 },
  { class: "Magic-User", level: 19, poison: 10, poly: 7, wand: 5, breath: 9, magic: 6 },
  { class: "Magic-User", level: 20, poison: 10, poly: 7, wand: 5, breath: 9, magic: 6 },
  // Thief
  { class: "Thief", level: 1, poison: 13, poly: 12, wand: 14, breath: 16, magic: 15 },
  { class: "Thief", level: 2, poison: 13, poly: 12, wand: 14, breath: 16, magic: 15 },
  { class: "Thief", level: 3, poison: 13, poly: 12, wand: 14, breath: 16, magic: 15 },
  { class: "Thief", level: 4, poison: 13, poly: 12, wand: 14, breath: 16, magic: 15 },
  { class: "Thief", level: 5, poison: 12, poly: 11, wand: 12, breath: 15, magic: 13 },
  { class: "Thief", level: 6, poison: 12, poly: 11, wand: 12, breath: 15, magic: 13 },
  { class: "Thief", level: 7, poison: 12, poly: 11, wand: 12, breath: 15, magic: 13 },
  { class: "Thief", level: 8, poison: 12, poly: 11, wand: 12, breath: 15, magic: 13 },
  { class: "Thief", level: 9, poison: 11, poly: 10, wand: 10, breath: 14, magic: 11 },
  { class: "Thief", level: 10, poison: 11, poly: 10, wand: 10, breath: 14, magic: 11 },
  { class: "Thief", level: 11, poison: 11, poly: 10, wand: 10, breath: 14, magic: 11 },
  { class: "Thief", level: 12, poison: 11, poly: 10, wand: 10, breath: 14, magic: 11 },
  { class: "Thief", level: 13, poison: 10, poly: 9, wand: 8, breath: 13, magic: 9 },
  { class: "Thief", level: 14, poison: 10, poly: 9, wand: 8, breath: 13, magic: 9 },
  { class: "Thief", level: 15, poison: 10, poly: 9, wand: 8, breath: 13, magic: 9 },
  { class: "Thief", level: 16, poison: 10, poly: 9, wand: 8, breath: 13, magic: 9 },
  { class: "Thief", level: 17, poison: 9, poly: 8, wand: 6, breath: 12, magic: 7 },
  { class: "Thief", level: 18, poison: 9, poly: 8, wand: 6, breath: 12, magic: 7 },
  { class: "Thief", level: 19, poison: 9, poly: 8, wand: 6, breath: 12, magic: 7 },
  { class: "Thief", level: 20, poison: 9, poly: 8, wand: 6, breath: 12, magic: 7 },

];

export const classForSavingThrows = {
  F: 'Fighter',
  Fi: 'Fighter',
  Fighter: 'Fighter',
  R: 'Fighter',
  Ra: 'Fighter',
  Rgr: 'Fighter',
  Ranger: 'Fighter',
  P: 'Fighter',
  Pa: 'Fighter',
  Pal: 'Fighter',
  Paladin: 'Fighter',
  C: 'Cleric',
  Cl: 'Cleric',
  Cleric: 'Cleric',
  D: 'Cleric',
  Dr: 'Cleric',
  Druid: 'Cleric',
  M: 'Magic-User',
  Mu: 'Magic-User',
  MU: 'Magic-User',
  'Magic-User': 'Magic-User',
  Mage: 'Magic-User',
  Ma: 'Magic-User',
  Wizard: 'Magic-User',
  I: 'Magic-User',
  Ill: 'Magic-User',
  ILL: 'Magic-User',
  Illusionist: 'Magic-User',
  Mo: 'Thief',
  Monk: 'Thief',
  T: 'Thief',
  Th: 'Thief',
  Thief: 'Thief',
  A: 'Thief',
  Ass: 'Thief',
  Assassin: 'Thief'
}